import { Availabilities } from 'api/menuMapping/types'
import { startCase, sortBy } from 'lodash'
import { DAYS_OF_WEEK } from 'utils'
import { AvailabilityList, AvailabilityRow, AvailableDay, AvailableTimeContainer, AvailableTime } from './../styles'

type Props = {
  availabilities: Availabilities[]
  isDisabled: boolean
}

const MenuHoursList = ({ availabilities, isDisabled }: Props) => {
  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase()

  // Filtering and sorting the enabled availabilities
  const enabledAvailabilities = availabilities.filter(availability => availability.enabled)
  const sortedAvailabilities = sortBy(enabledAvailabilities, item =>
    DAYS_OF_WEEK.indexOf(startCase(item.dayOfWeek))
  )

  const availabilitiesMap = sortedAvailabilities.reduce((acc, item) => {
    acc[item.dayOfWeek.toLowerCase()] = item
    return acc
  }, {} as Record<string, Availabilities>)

  return (
    <AvailabilityList>
      {DAYS_OF_WEEK.map(day => {
        const dayKey = day.toLowerCase()
        const availability = availabilitiesMap[dayKey]
        
        return (
          <AvailabilityRow key={day}>
            <AvailableDay isHighlighted={dayKey === today}>{day}</AvailableDay>
            <AvailableTimeContainer>
            {availability ? (
              availability.hours.split(',').map((hour, index) => {
                const formattedHour = hour.replace(/(AM|PM)/gi, ' $1')
                return (
                <AvailableTime key={index} isHighlighted={dayKey === today}>
                  {formattedHour}
                </AvailableTime>
                )}
              )
            ) : isDisabled ? (
              <div style={{ display: 'flex', gap: 16 }}>
                <AvailableTime key="na-1" isHighlighted={false}>N/A</AvailableTime>
                <AvailableTime key="na-2" isHighlighted={false}>N/A</AvailableTime>
              </div>
            ) : (
              <AvailableTime key="closed" isHighlighted={dayKey === today}>Closed</AvailableTime>
            )}
            </AvailableTimeContainer>
          </AvailabilityRow>
        )
      })}
    </AvailabilityList>
  )
}  

export default MenuHoursList